export default {
  LSN_1: {
    title: 'Posts',
    description: 'Sum of posts collected in the research.',
  },
  LSN_2: {
    title: 'Users',
    description: 'Count of unique users who generated the total posts in the research.',
  },
  LSN_3: {
    title: 'Net Promoter Score',
    description: 'Represents the result of the equation: (positive posts / collected posts * 100) - (negative posts / collected posts * 100).',
  },
  LSN_4: {
    title: 'Potential Reach',
    description: 'Represents 20% of the sum of followers/subscribers of profiles collected in the research.',
  },
  LSN_5: {
    title: 'Sentiment Index',
    description: 'Represents the result of the equation: (positive posts + neutral posts - negative posts) / total posts.',
  },
  LSN_6: {
    title: 'Sentiment Distribution',
    description: 'Division of posts by positive, negative, or neutral polarity.',
  },
  LSN_7: {
    title: 'Gender Distribution',
    description: 'Division of posts by Male, Female, and Organization.',
  },
  LSN_8: {
    title: 'Device Distribution',
    description: 'Division of posts by Mobile/Tablet and Computer.',
  },
  LSN_9: {
    title: 'Channel Distribution',
    description: 'Division of posts by collection channel (listening).',
  },
  LSN_10: {
    title: 'Top Influencers',
    description: 'Ranking of influencers ordered by the AAA methodology (influence score composed of Content Attractiveness, Research Affinity, and Influencer Reach).',
  },
  LSN_11: {
    title: 'Hottest Posts',
    description: 'Top posts displayed as a carousel, ranked by weighting between posting time and recently received engagement.',
  },
  LSN_12: {
    title: 'Correlated Terms',
    description: 'Displays the main terms related to the research within a time interval. Proximity indicates degree of relation. Ball size indicates post volume.',
  },
  LSN_13: {
    title: 'Posts Over Time',
    description: 'Linear distribution of collected posts over a time period.',
  },
  LSN_14: {
    title: 'Sentiment Over Time',
    description: 'Distribution of posts by polarity over a time period.',
  },
  LSN_15: {
    title: 'Sentiment by Term',
    description: 'Distribution of posts by most mentioned terms and their polarity breakdown.',
  },
  LSN_16: {
    title: 'Sentiment by Group',
    description: 'Distribution of posts by the most mentioned registered research Groups and their polarity breakdown.',
  },
  LSN_17: {
    title: 'Sentiment by Theme',
    description: 'Distribution of posts by the most mentioned registered research Themes and their polarity breakdown.',
  },
  LSN_18: {
    title: 'Text Annotations',
    description: 'Free editable text area for writing analyses, captions, and/or observations.',
  },
  LSN_19: {
    title: 'Insert Image',
    description: 'Component to insert images by file or URL.',
  },
  LSN_20: {
    title: 'Channels Over Time',
    description: 'Distribution of collected posts divided by collection channel over a time period.',
  },
  LSN_21: {
    title: 'Sentiment Gauge',
    description: 'Represents, as a gauge, the result of the equation: (positive posts / collected posts * 100) - (negative posts / collected posts * 100).',
  },
  LSN_22: {
    title: 'Most Liked Posts',
    description: 'List cards sorted by number of likes on collected posts (includes posts, publications, and interactions).',
  },
  LSN_23: {
    title: 'Most Recent Posts',
    description: 'List cards sorted by time of collected posts (includes posts, publications, and interactions).',
  },
  LSN_24: {
    title: 'Terms Cloud',
    description: 'Displays the most cited terms related to the research as a word cloud.',
  },
  LSN_25: {
    title: 'Section Divider',
    description: 'Text field for dashboard segment and section titles.',
  },
  LSN_26: {
    title: 'Posts with Most Followers',
    description: 'List cards sorted by follower count of the post profile.',
  },
  LSN_27: {
    title: 'Posts with Highest Engagement',
    description: 'List cards sorted by total engagement generated on the post.',
  },
  LSN_28: {
    title: 'Likes',
    description: 'Sum of likes on collected posts.',
  },
  LSN_29: {
    title: 'Comments',
    description: 'Sum of comments on collected posts.',
  },
  LSN_30: {
    title: 'Shares',
    description: 'Sum of shares on collected posts.',
  },
  LSN_31: {
    title: 'Engagement',
    description: 'Sum of all engagement actions on collected posts.',
  },
  LSN_32: {
    title: 'Engagement Over Time',
    description: 'Sum of all engagement actions collected on posts, displayed over the selected time period.',
  },
  LSN_33: {
    title: 'Sentiment by Channel',
    description: 'Distribution of posts by collected channels and their polarity breakdown.',
  },
  LSN_34: {
    title: 'Sentiment by Tag',
    description: 'Distribution of posts by research-registered Tags and their polarity breakdown.',
  },
  LSN_35: {
    title: 'Sentiment by Gender',
    description: 'Distribution of posts by gender and their polarity breakdown.',
  },
  LSN_36: {
    title: 'Mentions by Group Over Time',
    description: 'Distribution of posts by research-registered Groups over time.',
  },
  LSN_37: {
    title: 'Engagement by Group Over Time',
    description: 'Distribution of the sum of engagement actions collected on posts and classified into research Groups over time.',
  },
  LSN_38: {
    title: 'Posts by Theme Over Time',
    description: 'Distribution of posts by research-registered Themes over time.',
  },
  LSN_39: {
    title: 'Engagement by Theme Over Time',
    description: 'Distribution of the sum of engagement actions collected on posts and classified into research Themes over time.',
  },
  LSN_40: {
    title: 'Posts by Tag Over Time',
    description: 'Distribution of posts by assigned research Tags over time.',
  },
  LSN_41: {
    title: 'Engagement by Tag Over Time',
    description: 'Distribution of the sum of engagement actions collected on posts and classified by Tags over time.',
  },
  LSN_42: {
    title: 'Engagement by Group',
    description: 'Distribution of total interactions on posts by research groups.',
  },
  LSN_43: {
    title: 'Engagement by Themes',
    description: 'Distribution of total interactions on posts by research themes.',
  },
  LSN_44: {
    title: 'Engagement by Tags',
    description: 'Distribution of total interactions on posts by research tags.',
  },
  LSN_45: {
    title: 'Sentiment Over Time (Percentage)',
    description: 'Distribution of posts by percentage proportion of positive, negative, and neutral over a time period.',
  },
  LSN_46: {
    title: 'Posts by Group Over Time',
    description: 'Distribution of posts by research-registered Groups.',
  },
  LSN_47: {
    title: 'Posts by Theme',
    description: 'Distribution of posts by research-registered Themes.',
  },
  LSN_48: {
    title: 'Posts by Tag',
    description: 'Distribution of posts by assigned tags.',
  },
  LSN_49: {
    title: 'Fan Base Variation (Comparative)',
    description: 'Comparison between total fans before the start date and on the final date of the researched period (brands or competitors).',
  },
  LSN_50: {
    title: 'Total Fans (Comparative)',
    description: 'Total fans of the selected pages on the final date of the researched period (brands or competitors).',
  },
  LSN_51: {
    title: 'New Fans (Comparative)',
    description: 'Total fans gained by the selected pages in the researched period (brands or competitors).',
  },
  LSN_52: {
    title: 'Fan Base Evolution (Comparative)',
    description: 'Daily variation of fans of researched pages in the period, relative to the previous day (brands or competitors).',
  },
  LSN_53: {
    title: 'Media Distribution',
    description: 'Distribution of posts by most mentioned media and their polarity breakdown.',
  },
  LSN_54: {
    title: 'Advertising Equivalency',
  },
  LSN_55: {
    title: 'Portal Highlights',
  },
  LSN_56: {
    title: 'TV Highlights',
  },
  LSN_57: {
    title: 'Print Highlights',
  },
  LSN_58: {
    title: 'Radio Highlights',
  },
  LSN_59: {
    title: 'PR Score',
    description: 'Score based on a rating given to press articles.',
  },
  LSN_60: {
    title: 'Brand Health',
    description: 'Sums the percentage of positive and neutral mentions.',
  },
  LSN_61: {
    title: 'Brand Health by Group',
    description: 'Sums the percentage of positive and neutral mentions by group compared to the total mentions.',
  },
  LSN_62: {
    title: 'Brand Health by Theme',
    description: 'Sums the percentage of positive and neutral mentions by group compared to the total mentions.',
  },
  LSN_63: {
    title: 'Price vs. Mentions Comparison',
  },
  LSN_64: {
    title: 'Volume vs. Mentions Comparison',
  },
  LSN_65: {
    title: 'Price vs. Sentiment Comparison',
  },
  LSN_66: {
    title: 'Import File',
    description: 'Component to insert files by file or URL.',
  },
  LSN_67: {
    title: 'Import History',
    description: 'Component to view import history records.',
  },
  LSN_68: {
    title: 'Search',
    description: 'Component for free text search.',
  },
  LSN_69: {
    title: 'Annotations Report',
    description: 'Component for auditing annotations and status changes.',
  },
  LSN_70: {
    title: 'ChatGPT Response Suggestions',
    description: 'Component to generate automatic responses.',
  },
  LSN_71: {
    title: 'Sentiment by Tag with Tree Filter',
    description: 'Distribution of posts by research-registered Tags and their polarity breakdown.',
  },
  LSN_72: {
    title: 'Import Comments',
    description: 'Component to insert post comments via spreadsheet.',
  },
  LSN_73: {
    title: 'Channels by Group',
    description: 'Distribution of channels by research-registered Groups.',
  },
  LSN_74: {
    title: 'Posts by Group',
    description: 'Distribution of posts by research-registered groups.',
  },
  LSN_75: {
    title: 'Posts by Tag',
    description: 'Distribution of posts by assigned tags.',
  },
  LSN_76: {
    title: 'Posts by Theme',
    description: 'Distribution of posts by research-registered Themes.',
  },
  LSN_78: {
    title: 'Posts by Theme with Custom Filter',
    description: 'Distribution of posts by research-registered Themes.',
  },
  LSN_79: {
    title: 'Add Tags to Posts',
    description: 'Component to add tags to posts via spreadsheet import.',
  },
  LSN_80: {
    title: 'Post Sampling Projection',
    description: 'Projection of the volume of posts collected in the researched period, considering post sampling.',
  },
};
